<div class="sap-alert" [class.open]="isPanelVisible">  
  <button type="button" class="sap-alert-button" [class.visited]="hasNullAccountSummaryText() || allSessionSummariesOlderThan30Days()" (click)="openSummaryPanel()">
    <span *ngIf="summary?.lastUpdated">{{summary.lastUpdated | tzAbbr:currentTimeZone}}: </span><span class="visited-hide">LATEST&nbsp;</span>SELF-SERVICE ACTIVITY
    <app-euds-svg icon="feather/arrow-up-right" size="sm" class="icon-right"></app-euds-svg>
  </button>
  <div class="sap-summary-panel">
    <div class="title-bar">
      <app-euds-svg icon="feather/monitor-smartphone" size="md" class="title-icon-left"></app-euds-svg>
      <h3>Latest Self-Service Activity</h3>
      <button class="sap-close-btn" aria-label="Close Panel" (click)="closeSummaryPanel()"><app-euds-svg icon="feather/x" size="lg"></app-euds-svg></button>
    </div>  
    <p class="panel-message" *ngIf="allSessionSummariesOlderThan30Days()">No customer self-service activity in the last 30 days.</p>
    <div class="table-scroll" *ngIf="summary?.sessionSummaries?.length > 0 && !allSessionSummariesOlderThan30Days()">
      <table class="sap-session-summaries" aria-label="Session Summaries">
        <thead>
          <tr>
            <th class="status-icon"></th>
            <th class="activity-summary">Activity Summary</th>
            <th class="date">Date & Time</th>
            <th>Details</th>
            <th class="channel">Channel</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let session of summary.sessionSummaries; index as idx">
            <tr *ngIf="!thisSessionSummaryOlderThan30Days(session.lastUpdated)"
                [class.last-row-with-border]="feedbackDisabled || !showFeedbackIcons(session)"
                [class.activity-resolved]="isActivityResolved(session)">
              <!-- Status Icon Column -->
              <td class="status-icon">
                <div *ngIf="getActivityStatusIcon(session) as statusIcon"
                     [class]="statusIcon.cssClass"
                     [attr.aria-label]="statusIcon.ariaLabel"
                     role="img">
                  <app-euds-svg
                    [icon]="statusIcon.icon"
                    size="md">
                  </app-euds-svg>
                </div>
              </td>
              <!-- Activity Summary -->
              <td class="summary-text data-wrap">{{session.summaryText}}</td>
              <!-- Date & Time -->
              <td class="date">{{session.lastUpdated | tzAbbr:currentTimeZone:'date'}}<br />{{session.lastUpdated | tzAbbr:currentTimeZone:'time'}}</td>
              <!-- Details -->
              <td class="data-wrap">{{session.summaryResult}}</td>
              <!-- Channel -->
              <td class="channel">{{session.sourceChannel}}</td>
            </tr>
            <!-- Feedback Row - Only show if not disabled and not resolved -->
            <tr *ngIf="!feedbackDisabled && showFeedbackIcons(session) && !thisSessionSummaryOlderThan30Days(session.lastUpdated)" class="feedback-row">
              <td colspan="5" class="feedback-cell">
                <app-feedback-toggle
                  [sessionId]="getSessionId(session)"
                  [resultCode]="session.resultCode"
                  [initialState]="getFeedbackStateFor(session)"
                  (feedbackChange)="onFeedbackChange($event)">
                </app-feedback-toggle>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
